import React, { useState } from 'react';
import Modal from 'react-modal';
import '../LoginModals.css';
import { If } from 'react-extras';
import { UserFlowModalState } from '../../UserFlow/UserFlowModal';
import { customStyles } from '../../UserFlow/UserFlowModal';

const DefaultCase = (props: UserFlowModalState) => {
  const [ state, setState ] = useState(
    {
      showModal: true,
      disabled: true,
      rotate: false,
    }
  );

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const goToIRCTCRegistrationPage = () => {
    props.createAccount();
  };

  const { showModal, disabled, rotate } = state;
  const { allowClose } = props;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals htmlv3"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="makeFlex column">
        <div className="makeFlex spaceBetween">
          <div className="leftPanel">
            <p className="modalTitle font26 latoBloack blackText appendBottom40">
                Sorry! Something went wrong
            </p>
            <p className="font20 latoBold darkGreyText appendBottom20">
                Get IRCTC username
            </p>
            <ul className="font14 darkGreyText">
              <li>
                  Send an email requesting for your username to <a>care@irctc.co.in.</a> You will
                  receive an auto generated reply with a ticket code.
              </li>
              <li>
                  Call <a>customer care number</a> and tell them the ticket code or send another
                  email to <a>care@irctc.co.in</a> with your ticket code in the subject.
              </li>
              <li>
                  You should get your username on email within 24 hours.
              </li>
            </ul>
          </div>
          <div className="rightPanel">
            <If condition={allowClose === true}>
              <p className="textRight makeFlex spaceBetween start appendBottom40">
                <span
                  className="modalClose"
                  onClick={closeModal}
                >
                X
                </span>
              </p>
            </If>

            <p className="font20 latoBold darkGreyText appendBottom20">Get IRCTC password</p>

            <ul className="font14 darkGreyText">
              <li>
                  If you don’t remember your password,
                  you can select the option forgot password after entering your username.
              </li>
              <li>
                  You can then enter your IRCTC registered
                  mobile number to receive your password on SMS.
              </li>
              <li>
                  You will need to enter this password on the
                  IRCTC website after completing payment on MMT.
              </li>
            </ul>
          </div>
        </div>
        <div className="makeFlex spaceBetween modalFooter">
          <div className="font14 darkGreyText">
            <p className="appendBottom5 latoBold">Facing trouble?</p>
            <p className="font12">You can create a new account with a new email address and mobile number.</p>
          </div>
          <button
            onClick={goToIRCTCRegistrationPage}
            className={`${disabled ? '' : ''} width220 noShrink appendLeft15`}
          >
            <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>Create New Account</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DefaultCase;
